import { Center, Stack, Text, Box, BoxProps } from '@mantine/core';

const SearchIllustration = () => (
  <svg width='130' height='130' viewBox='0 0 130 130' fill='none' xmlns='http://www.w3.org/2000/svg'>
    {/* Soft coral bg circle */}
    <circle cx='65' cy='65' r='65' fill='#FFF3F0' />

    {/* Floating accent dots */}
    <circle cx='22' cy='38' r='6' fill='#FAC775' opacity='0.7' />
    <circle cx='108' cy='45' r='4' fill='#5DCAA5' opacity='0.6' />
    <circle cx='112' cy='90' r='7' fill='#AFA9EC' opacity='0.5' />
    <circle cx='18' cy='88' r='5' fill='#F0997B' opacity='0.6' />

    {/* Document */}
    <rect x='36' y='30' width='46' height='58' rx='5' fill='#fff' stroke='#F5C4B3' strokeWidth='1.5' />
    <rect x='44' y='42' width='30' height='5' rx='2.5' fill='#F0997B' />
    <rect x='44' y='53' width='22' height='4' rx='2' fill='#FAC775' opacity='0.8' />
    <rect x='44' y='63' width='26' height='4' rx='2' fill='#FAC775' opacity='0.6' />
    <rect x='44' y='73' width='18' height='4' rx='2' fill='#FAC775' opacity='0.4' />

    {/* Search circle bg */}
    <circle cx='83' cy='82' r='20' fill='#EEEDFE' stroke='#AFA9EC' strokeWidth='1.5' />

    {/* Magnifier ring */}
    <circle cx='80' cy='79' r='9' fill='none' stroke='#7F77DD' strokeWidth='2.5' />

    {/* Magnifier handle */}
    <line x1='87' y1='86' x2='94' y2='93' stroke='#7F77DD' strokeWidth='3' strokeLinecap='round' />

    {/* X inside magnifier */}
    <line x1='77' y1='76' x2='83' y2='82' stroke='#AFA9EC' strokeWidth='1.8' strokeLinecap='round' />
    <line x1='83' y1='76' x2='77' y2='82' stroke='#AFA9EC' strokeWidth='1.8' strokeLinecap='round' />
  </svg>
);

interface NoMenuItemsProps extends BoxProps {
  title?: string;
  description?: string;
}

export function NoMenuItems({
  title = 'No menu items found',
  description = 'Try a different category or check back later',
  ...others
}: NoMenuItemsProps) {
  return (
    <Box
      sx={(theme) => ({
        background: theme.white,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: theme.radius.lg,
        padding: '48px 24px',
      })}
      {...others}>
      <Center>
        <Stack align='center' spacing='xs'>
          <SearchIllustration />

          <Text size='md' weight={500} color='dark' mt={4}>
            {title}
          </Text>

          <Text size='sm' color='dimmed' align='center' maw={210}>
            {description}
          </Text>
        </Stack>
      </Center>
    </Box>
  );
}

export default NoMenuItems;
